
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billing/documents",
      function () {
        return require("private-next-pages/billing/documents.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/billing/documents"])
      });
    }
  